
import AdsApi from '../libs/ads-request/ads-api';
import _const from '../const';
import { downloadFile, validateAccess } from '../libs/helpers';
import Contact from './ContactComponent.vue';

const NO_DATA_LABEL = 'S/R';

export default {
  name: 'ReceptionComponent',
  components: {
    Contact,
  },
  data: () => ({
    isExpandedPersonalInformation: true,
    isExpandedVehicleInformation: true,
    orderInfo: {},
    total: 0,
    orderActual: '',
    customerAddress: '',
    userData: null,
    brand: '',
    noDataLabel: NO_DATA_LABEL,
  }),
  computed: {
    isPaymentEnabled() {
      return validateAccess(_const.MODULE_PAYMENT);
    },
    isInvoiceEnabled() {
      return validateAccess(_const.MODULE_INVOICES);
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
    phoneCustomerNumber() {
      if (this.$session.get('customerPhone')) {
        return `(${this.$session.get('customerPhone').slice(0, 3)}) ${this.$session.get('customerPhone').slice(3, 10)}`;
      }

      return NO_DATA_LABEL;
    },
    existContactData() {
      const name = this.$session.get('nameContact');
      return typeof name === 'string' && name.trim() !== '';
    },
    isBrand() {
      return this.brand === 'cupra' ? 'color-cupra' : 'text-white';
    },
    sessionOrders() {
      const orders = this.$session.get('orders');
      return Array.isArray(orders) ? orders : [];
    },
  },
  mounted() {
    const orders = this.sessionOrders;

    this.orderActual = orders.length > 0 ? (orders[0]?.orderIdDMS || NO_DATA_LABEL) : NO_DATA_LABEL;

    if (this.existContactData) {
      this.setContactData();
    } else {
      this.setCustomerData();
    }
    this.setCustomerAddress();
    this.brand = this.$session.get('brand') || '';
  },
  methods: {
    downloadPDFStatus() {
      this.loaderShow('Descargando PDF');
      AdsApi.getReceptionPdf(this.orderInfo.order_id)
        .then((response) => {
          const { data } = response;

          downloadFile(data.file, `${data.nameFile}.${data.extension}`, data.mime);
        })
        .catch((err) => this.alertShow(err, 'error'))
        .then(this.loaderHide);
    },
    setCustomerData() {
      this.userData = {
        name: this.$session.get('customerName') || NO_DATA_LABEL,
        tel: this.phoneCustomerNumber,
        email: this.$session.get('email') || NO_DATA_LABEL,
      };
    },
    setContactData() {
      this.userData = {
        name: this.$session.get('nameContact') || NO_DATA_LABEL,
        tel: this.$session.get('cellphoneContact') || NO_DATA_LABEL,
        email: this.$session.get('emailContact') || NO_DATA_LABEL,
      };
    },
    setCustomerAddress() {
      if (this.$session.get('customerAddress')) {
        this.customerAddress = this.$session.get('customerAddress').replace(/[^a-zA-ZÀ-ÿ0-9_]/g, ' ');
      } else {
        this.customerAddress = NO_DATA_LABEL;
      }
    },
  },
};
